export const replaceNonEnglishChars = (input) => {
    const charMap = {
        á: 'a',
        č: 'c',
        é: 'e',
        ě: 'e',
        í: 'i',
        ň: 'n',
        ó: 'o',
        ř: 'r',
        š: 's',
        ť: 't',
        ú: 'u',
        ů: 'u',
        ý: 'y',
        ž: 'z',
        è: 'e',
        à: 'a',
        ù: 'u',
        ë: 'e',
        ï: 'i',
        ü: 'u',
        ö: 'o',
        ä: 'a',
        ß: 'ss',
        ç: 'c',
        ñ: 'n',
        å: 'a',
        æ: 'ae',
        œ: 'oe',
        ô: 'o',
        ê: 'e',
        â: 'a',
        î: 'i',
        û: 'u',
        ÿ: 'y',
        // Add more mappings as needed
    };
    return input
        .split('')
        .map((char) => charMap[char] || char)
        .join('');
};
